module.exports = __webpack_public_path__ + "img/m-sch.7353b79b.svg";